/* tslint:disable */
/* eslint-disable */
export enum Company {
  Capital = 'CAPITAL',
  Investments = 'INVESTMENTS'
}
